import backendAPI from './backendAPI'

const STORAGE_KEY = 'klerk_referral_token'

export const getStoredReferralToken = () => localStorage.getItem(STORAGE_KEY) || ''

export const captureReferralFromUrl = async () => {
	const params = new URLSearchParams(window.location.search)
	const tokenFromUrl = (params.get('ref') || '').trim()
	if (!tokenFromUrl) return

	// First-click attribution: keep the earliest token only.
	if (!localStorage.getItem(STORAGE_KEY)) {
		localStorage.setItem(STORAGE_KEY, tokenFromUrl)
	}

	try {
		await backendAPI.post('/api/stripe/referrals/click/', {
			referralToken: tokenFromUrl,
			landingPath: `${window.location.pathname}${window.location.search}`,
		})
	} catch (err) {
		console.debug('Referral click tracking failed', err)
	}
}
